import api from './utilBackoffice';

const controller = 'ControleOperacao';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Post: dto => {
    return api.Axios.Post(url + '/Upload', dto);
  },
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  DownloadFile: (dto, fileName) => {
    return api.Axios.DownloadExcelFile(url + '/DownloadFile', dto, fileName);
  }
});
